// mutations
const SET_MASTER_CAREER_TRANSISI = (state, payload) => {
  state.resMasterCareerTransisition = payload;
};
const SET_CAREER_TRANSISI_TYPE = (state, payload) => {
  state.type_career = payload;
};
const SET_CAREER_TRANSISI_REASON = (state, payload) => {
  state.reason_career = payload;
};
const SET_FORM_INPUR = (state, payload) => {
  state.formInput = payload;
};
const SET_ID = (state, payload) => {
  state.id = payload;
};
const SET_RESUSER = (state, payload) => {
  state.user_career = payload;
};
export default {
  SET_MASTER_CAREER_TRANSISI,
  SET_CAREER_TRANSISI_REASON,
  SET_CAREER_TRANSISI_TYPE,
  SET_FORM_INPUR,
  SET_ID,
  SET_RESUSER
};
